require('!!file-loader?name=[name].[ext]!./index.html');
require('./index.css');

var $ = require('jquery');
var gists = require('./gists');
var hljs = require('./highlight');

window._demo = {};

$(function() {
    var demoHtml = $('#demoHtml').html();

    $('.demo').each(function(demoIndex) {
        var $demo = $(this);
        var demoPanel = $demo.html();
        var gist = gists[$demo.data('gist')];
        var consoleName = 'console' + demoIndex;
        var replacements = {
            gist: gist.replace('$$var_', 'window.'),
            console: '_demo.' + consoleName
        };
        var script = gists._wrap.replace(/\$\$(\w+)/g, function(_, key) { return replacements[key]; });
        var scriptView = gist.replace('$$var_', 'var ');

        $demo.html(require('./templates/demo.html')).find('.demo-panel').html(demoPanel);

        window._demo[consoleName] = createConsole($('.demo-output pre', $demo));

        hljs.highlightBlock($('<code class="javascript"></code>')
            .text(scriptView)
            .appendTo($('.demo-script .code', $demo))
            .get(0));

        $('.demo-run', $demo).on('click', function() {
            $('<script></script>').html(script).appendTo($('body'));
        });
    });
});

function createConsole(elem) {
    return {
        log: function(title, content) {
            console.log.apply(console, arguments);
            var text = typeof(content) === 'object' ? JSON.stringify(content, null, 2) : content;
            return elem
                .empty()
                .append($('<b></b>').text(title))
                .append(' ')
                .append($('<span></span>').text(text))
                .append('\n');
        }
    };
}
